// TODO - remove lint disable when editing this file
/* eslint-disable */
import Factory from './util/Factory'
import HeadlineConverter from './converters/HeadlineConverter'
import SubheadlineConverter from './converters/SubheadlineConverter'

const headlineFactory = new Factory()

headlineFactory.addConverter(new HeadlineConverter())
headlineFactory.addConverter(new SubheadlineConverter())

export default headlineFactory
